// src/components/AddQuestionForm.jsx
import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../Config/config';

const AddQuestionForm = ({ onAdd, track }) => {
 const [form, setForm] = useState({
 technology: track,
 level: 1,
 question: '',
 option_a: '',
 option_b: '',
 option_c: '',
 option_d: '',
 correct_option: 'A',
 });

 const handleChange = (e) => {
 setForm({ ...form, [e.target.name]: e.target.value });
 };

 const handleSubmit = async (e) => {
 e.preventDefault();
 try {
 const res = await axios.post(`${API_BASE_URL}/admin-questions/track/${track}`, form, {
 headers: {
 'Content-Type': 'application/json',
 },
 });

 onAdd(res.data);
 setForm({
 technology: track,
 level: 1,
 question: '',
 option_a: '',
 option_b: '',
 option_c: '',
 option_d: '',
 correct_option: 'A',
 });
 } catch (err) {
 console.error('Error adding question:', err);
 alert('Failed to add question. Please check the server or network.');
 }
 };

 return (
 <form
 onSubmit={handleSubmit}
 className="bg-bgSection text-heading p-8 rounded-3xl shadow-2xl mb-10 border border-accentGray/30 relative overflow-hidden"
 >
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -mr-32 -mt-32"></div>
 
 <h3 className="text-xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-6 relative z-10">Add New Question</h3>
 
 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
 <div className="space-y-2">
 <label className="block text-muted font-bold text-xs uppercase tracking-widest">Level</label>
 <input
 type="number"
 name="level"
 placeholder="e.g. 1"
 value={form.level}
 onChange={handleChange}
 className="w-full p-4 rounded-2xl bg-bgMain border border-accentGray/50 text-white focus:border-primary outline-none transition-all"
 required
 />
 </div>
 
 <div className="md:col-span-2 space-y-2">
 <label className="block text-muted font-bold text-xs uppercase tracking-widest">Question Text</label>
 <textarea
 name="question"
 placeholder="Type your question here..."
 value={form.question}
 onChange={handleChange}
 rows="2"
 className="w-full p-4 rounded-2xl bg-bgMain border border-accentGray/50 text-white focus:border-primary outline-none transition-all"
 required
 />
 </div>

 {["a","b","c","d"].map((opt) => (
 <div key={opt} className="space-y-2">
 <label className="block text-muted font-bold text-xs uppercase tracking-widest">Option {opt.toUpperCase()}</label>
 <input
 type="text"
 name={`option_${opt}`}
 placeholder={`Answer choice ${opt.toUpperCase()}`}
 value={form[`option_${opt}`]}
 onChange={handleChange}
 className="w-full p-4 rounded-2xl bg-bgMain border border-accentGray/50 text-white focus:border-primary outline-none transition-all"
 required
 />
 </div>
 ))}

 <div className="md:col-span-2 space-y-2">
 <label className="block text-muted font-bold text-xs uppercase tracking-widest">Correct Answer</label>
 <select
 name="correct_option"
 value={form.correct_option}
 onChange={handleChange}
 className="w-full p-4 rounded-2xl bg-bgMain border border-accentGray/50 text-white focus:border-primary outline-none transition-all"
 >
 <option value="A">Option A</option>
 <option value="B">Option B</option>
 <option value="C">Option C</option>
 <option value="D">Option D</option>
 </select>
 </div>
 </div>

 <div className="mt-8 relative z-10">
 <button 
 type="submit" 
 className="btn-primary-gradient px-10 py-4 font-bold shadow-xl hover:scale-105 active:scale-95 transition-all w-full md:w-auto"
 >
 Add Question to Track
 </button>
 </div>
 </form>
 );
};

export default AddQuestionForm;



